<template>
  <div class="notifications-page">
    <div class="notifications-header">
      <h1 class="text-xl font-semibold">
        {{ $t('hit-admin.notifications.title') }}
      </h1>
      <div class="tabs">
        <button
          type="button"
          class="tab"
          :class="{active: activeTab === 'new'}"
          @click="activeTab = 'new'"
        >
          {{ $t('hit-admin.notifications.tab-new') }}
        </button>
        <button
          type="button"
          class="tab"
          :class="{active: activeTab === 'history'}"
          @click="onHistoryTab"
        >
          {{ $t('hit-admin.notifications.tab-history') }}
        </button>
      </div>
    </div>

    <div class="notifications-body">
      <notification-broadcast-form
        v-if="activeTab === 'new'"
        @sent="onBroadcastSent"
      />
      <notification-broadcast-list v-else ref="historyList" />
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';
import NotificationBroadcastForm from './NotificationCampaignForm.vue';
import NotificationBroadcastList from './NotificationCampaignList.vue';

export default defineComponent({
  name: 'NotificationsPage',
  components: {
    NotificationBroadcastForm,
    NotificationBroadcastList,
  },
  data() {
    return {
      activeTab: 'new',
    };
  },
  methods: {
    onHistoryTab() {
      this.activeTab = 'history';
      this.$nextTick(() => {
        this.$refs.historyList?.reload?.();
      });
    },
    onBroadcastSent() {
      this.activeTab = 'history';
      this.$nextTick(() => {
        this.$refs.historyList?.reload?.();
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.notifications-page {
  padding: 0.75rem;
  height: 100%;
  display: grid;
  grid-template-rows: max-content minmax(0, 1fr);
  gap: 0.75rem;
}

.notifications-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.5rem 0.65rem;
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
  background: rgba(255, 255, 255, 0.72);
  border-radius: 0.75rem;
}

.tabs {
  display: flex;
  gap: 0.35rem;
}

.tab {
  padding: 0.4rem 0.85rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  border: 1px solid rgba(15, 23, 42, 0.12);
  background: white;
  cursor: pointer;
  &.active {
    background: #00997c;
    color: white;
    border-color: #00997c;
  }
}

.notifications-body {
  min-height: 0;
  overflow-y: auto;
}
</style>
